module.exports = __webpack_public_path__ + "media/Components/Logos/icon-tool-delete-5effd7210ad1cbf84802f4f1035f85a6.svg";